// Restituisce il nome della categoria primaria o sottocategoria primaria
export const getPrimaryCategoryName = (categories) => {
    const primaryCategory = categories?.find(cat => cat.isPrimary);
    const primarySubcategory = categories?.flatMap(cat => cat.subcategories || []).find(sub => sub.isPrimary);
    return primaryCategory?.name || primarySubcategory?.name || null;
};

// Restituisce l'URL della categoria primaria o sottocategoria primaria
export const getPrimaryCategoryUrl = (categories) => {
    const primaryCategory = categories?.find(cat => cat.isPrimary);
    const primarySubcategory = categories?.flatMap(cat => cat.subcategories || []).find(sub => sub.isPrimary);
    return primaryCategory?.url || primarySubcategory?.url || null;
};
